import { h } from "preact";
import IconVolumeUp from "./icons/IconVolumeUp";
import IconVolumeMute from "./icons/IconVolumeMute";

const NotificationSoundButton = ({
    gtmIdSoundOn,
    gtmIdSoundOff,
    GA4IdSoundOn,
    GA4IdSoundOff,
    g4Name,
    activated,
    toggleSound,
    label,
    buttonClassName,
    buttonSizeClassName = "fxs_btn_xsmall",
}) => (
    <button
        type="button"
        data-gtmid={activated ? gtmIdSoundOff :  gtmIdSoundOn}
        data-ga4event-clk-name={ g4Name }
        data-ga4event-element={activated ? GA4IdSoundOff :  GA4IdSoundOn}

        class={`fxs_btn ${buttonSizeClassName} fxs_notification ${
            buttonClassName || ""
        }`}
        onClick={toggleSound}

    >
        <span>{label}</span>
        {activated ? <IconVolumeUp /> : <IconVolumeMute />}
        <span  class={`fxs_notification_slider ${activated ? 'fxs_notification_slider_active':'fxs_notification_slider_inactive'}`}/>
    </button>
);

export default NotificationSoundButton;
